import { Globe, ExternalLink } from "lucide-react";

const hostOf = (url = "") => {
  try { return new URL(url).hostname.replace(/^www\./, ""); } catch { return url; }
};

// Renders a proposal "Website Showcase" section: a grid of live-website preview
// cards (image + title + description + visit link). Shared across all templates
// and the public proposal view.
const WebsiteShowcaseSection = ({ section, primaryColor = "#0058c3" }: any) => {
  const items: any[] = section?.content?.items || [];
  if (!items.length) return null;
  const cols = section?.layout === "grid-3" ? "sm:grid-cols-3" : "sm:grid-cols-2";

  return (
    <section className="py-10 px-6 max-w-5xl mx-auto">
      {section.title && <h2 className="text-2xl font-bold mb-6 text-center text-slate-800">{section.title}</h2>}
      <div className={`grid grid-cols-1 ${cols} gap-6`}>
        {items.map((w, i) => (
          <a
            key={i}
            href={w.url}
            target="_blank"
            rel="noreferrer"
            className="group block rounded-2xl overflow-hidden border border-slate-200 bg-white hover:shadow-lg transition-shadow"
          >
            <div className="aspect-[16/9] bg-slate-100 overflow-hidden">
              {w.image ? (
                <img src={w.image} alt={w.title || w.url} className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300" />
              ) : (
                <div className="w-full h-full grid place-items-center text-slate-300"><Globe size={40} /></div>
              )}
            </div>
            <div className="p-4">
              <div className="flex items-center gap-1.5 text-[11px] text-slate-500 mb-1">
                <Globe size={12} /> {w.siteName || hostOf(w.url)}
              </div>
              <h3 className="font-bold text-slate-800 line-clamp-1">{w.title || w.url}</h3>
              {w.description && <p className="text-[13px] text-slate-500 mt-1 line-clamp-2">{w.description}</p>}
              <span className="inline-flex items-center gap-1 text-[13px] font-semibold mt-3" style={{ color: primaryColor }}>
                Visit Website <ExternalLink size={13} />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default WebsiteShowcaseSection;
